export enum GcpRequestStatus {
  CLOSED = 'CLOSED',
  OPEN = 'OPEN',
}
